module.exports = __webpack_public_path__ + "static/media/undraw_cancel_u1it.cbc8724a.svg";